module.exports = __webpack_public_path__ + "static/img/struct3.f378ee9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/struct3.png
// module id = W0nz
// module chunks = 1